import BsLoader from './index.vue'
export default BsLoader